import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Label from 'components/atoms/Label';
import { bindActionCreators, Dispatch } from 'redux';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { Layout, RootState } from 'types';
import { MainControlsInterface } from 'types/functions';
import { ActionsType, SystemType } from 'types/system';
import { checkDifferent, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface SearchVesselTransitModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    layout: Layout;
    mainControls: MainControlsInterface;
    system: SystemType;
    id?: string;
    setLayoutAction: SetLayoutAction;
    //unused props but used in state and getDerivedStateFromProps
    data: any;
    actions: ActionsType | undefined;
}

interface SearchVesselTransitModelState {
    //unused state
    errors: object;

    system: SystemType;

    //unused state
    data: any | null;
}

class SearchVesselTransitModel extends Component<SearchVesselTransitModelProps, SearchVesselTransitModelState> {
    constructor(props: SearchVesselTransitModelProps) {
        super(props);
        this.state = {
            system: props.system,
            data: {
                date: 'thisMonth',
            },
            errors: {},
        };
    }

    static getDerivedStateFromProps(props: SearchVesselTransitModelProps, state: SearchVesselTransitModelState) {
        if (checkDifferent(props.system, state.system)) {
            return { system: props.system };
        }
        return null;
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.mainControls.searchVesselLastTransit(this.props.data.vessel.name, this.state.data.date);
        this.props.actions?.onCancel();
    };
    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;
        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('search for recent transits')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div className="mt-5 flex items-center gap-1 text-md text-gray-600">
                        {translate('finding vessel last known transit during the previous', {
                            vesselName: this.props.data.vessel.name,
                            dateRange: translate(this.state.data.date),
                        })}
                    </div>
                    <FormGroup required={false}>
                        <Label>{translate('Date range')}</Label>
                        <DropList  capitalize
                            id="date"
                            name="date"
                            options={[
                                { value: 'today', label: translate('today') },
                                { value: 'yesterday', label: translate('yesterday') },
                                { value: 'thisWeek', label: translate('This week') },
                                { value: 'lastWeek', label: translate('last week') },
                                { value: 'thisMonth', label: translate('This month') },
                                { value: 'lastMonth', label: translate('last month') },
                                { value: 'thisYear', label: translate('This year') },
                                { value: 'allTimes', label: translate('all time') },
                            ]}
                            value={this.state.data.date}
                            onChange={this.handleChange}
                        />
                    </FormGroup>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Search')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const searchVesselTransitModelStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    system: state.port.system,
    mainControls: state.layout.mainControls,
});

const searchVesselTransitModelDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(
    searchVesselTransitModelStateToProps,
    searchVesselTransitModelDispatchToProps
)(SearchVesselTransitModel);
